const ORGANIZER_PROFILES = {
  "owner-a1-auto": {
    offerTags: ["Mechanic"],
    offerSkills: [
      {
        id: "skill-1",
        name: "Mechanic",
        description: "Mobile automotive services throughout Glenwood. Mobile workshop for vehicle diagnostics and repairs.",
      },
    ],
    exchangeType: "payment",
    testimonials: [
      {
        id: 1,
        name: "Sarah M.",
        rating: 5,
        date: "2 weeks ago",
        comment:
          "Great service from Phil! He came to my place and fixed my car quickly. Very professional and honest pricing. Highly recommend!",
      },
      {
        id: 2,
        name: "Mike T.",
        rating: 5,
        date: "1 month ago",
        comment:
          "Phil did an excellent job on my brake repairs. Mobile service is so convenient and the work was top quality. Will definitely use again!",
      },
      {
        id: 3,
        name: "Emma L.",
        rating: 4,
        date: "2 months ago",
        comment:
          "Phil was very knowledgeable and fixed my engine issue. Good communication and fair pricing. Reliable mobile mechanic services.",
      },
      {
        id: 4,
        name: "David R.",
        rating: 5,
        date: "3 months ago",
        comment:
          "Phil came out for an emergency repair and got me back on the road quickly. Professional service and great value. My go-to mechanic now!",
      },
      {
        id: 5,
        name: "Lisa K.",
        rating: 5,
        date: "4 months ago",
        comment:
          "Phil has worked on my vehicles multiple times. Always reliable, honest, and does quality work. Best mobile mechanic service in Glenwood!",
      },
    ],
  },

  "owner-bcr-diesel": {
    name: "Benn Breasley",
    offerTags: ["Mechanic"],
    offerSkills: [
      {
        id: "skill-1",
        name: "Mechanic",
        description: "Diesel engine repairs and maintenance services for trucks, 4WDs, and heavy machinery.",
      },
    ],
    exchangeType: "payment",
    email: "benn.breasley@bcrdiesel.com.au",
    location: "Gunalda",
    rating: 5.0,
    reviewCount: 2,
    testimonials: [
      {
        id: 1,
        name: "Jake M.",
        rating: 5,
        date: "1 month ago",
        comment:
          "Benn is an absolute legend! Fixed my truck perfectly and went above and beyond. Best diesel mechanic around, highly recommend my mate Benn!",
        providerResponse: {
          text: "Thanks heaps, Jake! Really appreciate the kind words. Your truck was a fun challenge and I'm stoked it's running perfectly for you now!",
          date: "3 weeks ago",
          providerName: "Benn Breasley",
        },
      },
      {
        id: 2,
        name: "Sam T.",
        rating: 5,
        date: "2 months ago",
        comment:
          "Top bloke Benn! Did an amazing job on my 4WD diesel engine. Really knows his stuff and great prices. Couldn't be happier with the service!",
        providerResponse: {
          text: "Cheers, Sam! Glad I could get your 4WD sorted. Always happy to help out fellow diesel owners. Thanks for the business!",
          date: "6 weeks ago",
          providerName: "Benn Breasley",
        },
      },
    ],
  },

  "owner-alex-harvey": {
    offerTags: ["Music"],
    offerSkills: [
      {
        id: "skill-1",
        name: "Music",
        description: "Professional music education services. Specializes in saxophone lessons for all ages. Can be booked for performances in and around the Gympie area.",
      },
    ],
    exchangeType: "payment",
    testimonials: [
      {
        id: 1,
        name: "Sarah M.",
        rating: 5,
        date: "1 week ago",
        comment: "Alex is an amazing music teacher! My daughter has learned so much in just a few months. Patient, knowledgeable, and makes learning fun. Highly recommend!",
        providerResponse: {
          text: "Thank you so much, Sarah! It's been wonderful teaching your daughter. She's making excellent progress!",
          date: "5 days ago",
          providerName: "Alex Harvey",
        },
      },
      {
        id: 2,
        name: "Mike T.",
        rating: 5,
        date: "2 weeks ago",
        comment: "Alex performed at our wedding and it was absolutely perfect! Beautiful saxophone music that made our special day even more memorable. Professional and talented.",
        providerResponse: {
          text: "Thank you, Mike! It was an honor to be part of your special day. Congratulations again!",
          date: "1 week ago",
          providerName: "Alex Harvey",
        },
      },
      {
        id: 3,
        name: "Emma L.",
        rating: 5,
        date: "3 weeks ago",
        comment: "Best saxophone teacher I've ever had! Alex's teaching style is clear and encouraging. I've improved so much in jazz improvisation. Excellent instructor!",
        providerResponse: {
          text: "Thank you, Emma! Your dedication to practice is really showing. Keep up the great work!",
          date: "2 weeks ago",
          providerName: "Alex Harvey",
        },
      },
      {
        id: 4,
        name: "David R.",
        rating: 5,
        date: "1 month ago",
        comment: "Alex gave a fantastic performance at our corporate event. Professional, punctual, and the music was outstanding. Will definitely book again!",
      },
      {
        id: 5,
        name: "Lisa K.",
        rating: 5,
        date: "2 months ago",
        comment: "My son loves his saxophone lessons with Alex! Great teacher who knows how to connect with kids and make music enjoyable. Highly skilled educator!",
      },
      {
        id: 6,
        name: "John P.",
        rating: 5,
        date: "2 months ago",
        comment: "Alex's music lessons have been transformative. Clear instruction, great technique tips, and wonderful encouragement. I've progressed faster than expected!",
      },
      {
        id: 7,
        name: "Karen W.",
        rating: 5,
        date: "3 months ago",
        comment: "Outstanding saxophonist! Alex performed at our anniversary party and everyone was impressed. Beautiful music and professional service. Highly recommended!",
      },
      {
        id: 8,
        name: "Tom B.",
        rating: 5,
        date: "3 months ago",
        comment: "Alex is a fantastic teacher with incredible patience. My daughter has developed a real love for music thanks to these lessons. Worth every penny!",
      },
      {
        id: 9,
        name: "Rachel S.",
        rating: 5,
        date: "4 months ago",
        comment: "Professional, talented, and passionate about music. Alex's lessons have helped me improve my saxophone skills significantly. Great teacher and performer!",
      },
      {
        id: 10,
        name: "Jessica P.",
        rating: 2,
        date: "3 weeks ago",
        comment: "Not happy with the lesson scheduling. Alex cancelled our lesson twice and then rescheduled at the last minute. Very unprofessional. I expected better communication.",
        providerResponse: {
          text: "I apologize for the inconvenience, Jessica. I've reviewed our communication and I offered multiple reschedule options each time due to an emergency. I'm happy to provide a make-up lesson at your convenience. Please contact me directly so we can resolve this.",
          date: "2 weeks ago",
          providerName: "Alex Harvey",
        },
      },
    ],
  },

  "owner-william-gardener": {
    name: "William The Gardener",
    offerTags: ["Gardening", "Lawn Mowing"],
    offerSkills: [
      {
        id: "skill-1",
        name: "Gardening",
        description: "Professional landscaping and garden maintenance. 10+ years experience with native plants and sustainable gardening practices.",
      },
      {
        id: "skill-2",
        name: "Lawn Mowing",
        description: "Regular lawn care, edging, and trimming. Eco-friendly practices and attention to detail.",
      },
    ],
    seekSkills: [
      {
        id: "skill-3",
        name: "Plumber",
        description: "Need help with leaky faucets and basic plumbing repairs for my home.",
      },
      {
        id: "skill-4",
        name: "Electrician",
        description: "Looking for assistance with lighting installations and basic electrical work.",
      },
    ],
    exchangeType: "payment",
    email: "john.smith@email.com",
    location: "Bundaberg, QLD",
    rating: 4.8,
    reviewCount: 34,
    testimonials: [
      {
        id: 1,
        name: "Sarah M.",
        rating: 5,
        date: "2 weeks ago",
        comment:
          "William did an amazing job transforming our garden! His knowledge of native plants is impressive and the results speak for themselves.",
      },
      {
        id: 2,
        name: "Mike T.",
        rating: 5,
        date: "1 month ago",
        comment:
          "Professional service from start to finish. William was punctual, friendly, and his work is top quality. Highly recommend!",
      },
      {
        id: 3,
        name: "Emma L.",
        rating: 4,
        date: "2 months ago",
        comment:
          "Great communication and excellent garden maintenance. Very satisfied with the service and attention to detail.",
      },
    ],
  },
};

export function getOrganizerProfile(organizerId) {
  return ORGANIZER_PROFILES[organizerId] || {};
}
